import request from '@/utils/request'

// 查询质量提升-服务标准-1对 1 服务申请信息列表
export function list1to1sqxx(query) {
  return request({
    url: '/web/zlts/1to1sqxx/list',
    method: 'get',
    params: query
  })
}

// 查询质量提升-服务标准-1对 1 服务申请信息详细
export function get1to1sqxx(recid) {
  return request({
    url: '/web/zlts/1to1sqxx/' + recid,
    method: 'get'
  })
}

// 新增质量提升-服务标准-1对 1 服务申请信息
export function add1to1sqxx(data) {
  return request({
    url: '/web/zlts/1to1sqxx',
    method: 'post',
    data: data
  })
}

// 修改质量提升-服务标准-1对 1 服务申请信息
export function update1to1sqxx(data) {
  return request({
    url: '/web/zlts/1to1sqxx/edit',

    method: 'post',
    data: data
  })
}

// 删除质量提升-服务标准-1对 1 服务申请信息
export function del1to1sqxx(recid) {
  return request({
    url: '/web/zlts/1to1sqxx/remove/' + recid,

    method: 'post',
  })
}

// 导出质量提升-服务标准-1对 1 服务申请信息
export function export1to1sqxx(query) {
  return request({
    url: '/web/zlts/1to1sqxx/export',
    method: 'get',
    params: query
  })
}